import { Tabs } from 'antd';
import { useSelector } from 'react-redux';
import PostContentEditorDetailsV2 from './PostContentEditorDetailsV2';

const PostContentEditor = ({ autopublishByEmployee = {} }) => {
	const selectedEmployees = useSelector((state) => state.dist.selected_employees);
	const jobStatus = useSelector((state) => state.dist.jobStatus);

	if (!selectedEmployees.length) {
		return (
			<div className="text-center text-gray-500 mt-4 w-full bg-white border rounded-xl p-4 shadow-sm">
				Select employees to distribute posts to
			</div>
		);
	}

	const items = selectedEmployees.map((emp) => {
		const job = jobStatus[emp.id];
		let statusIcon = '🕓';
		if (job?.status === 'completed') statusIcon = '✅';
		else if (job?.status === 'queued') statusIcon = '🔄';
		else if (job?.status === 'delayed') statusIcon = '⌛️';
		else if (job?.status === 'failed') statusIcon = '❌';
		else if (job?.status === 'active') statusIcon = '⌛️';

		return {
			key: String(emp.id),
			label: `${statusIcon} ${emp.fullName}`,
			children: (
				<div className="p-4">
					<PostContentEditorDetailsV2
						employeeId={emp.id}
						// Pass per-user autopublish boolean; undefined → false
						autopublish={!!autopublishByEmployee[emp.id]}
					/>
				</div>
			),
		};
	});

	return <Tabs type="card" tabPosition="top" items={items} />;
};

export default PostContentEditor;
